import { render, staticRenderFns } from "./accoutingFirmYearReport.vue?vue&type=template&id=1ab58c70&scoped=true"
import script from "./accoutingFirmYearReport.vue?vue&type=script&lang=js"
export * from "./accoutingFirmYearReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab58c70",
  null
  
)

export default component.exports